import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import { connect } from "react-redux";
import { DollarSign } from "react-feather";
import {
  getAllTransactionRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
} from "../../../actions";
import { Link } from "react-router-dom";

import AllTransactions from "./allTransactions.js";
import { getSingleProduct } from "../../../firebase/firebase.utils.js";
class SellsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourcingObj: null,
      filterCountry: "",
      selectedMonth: "",
      agentPaid: 0,
      product: null,
      variationId: "",
    };
  }

  componentDidMount = async () => {
    const { id, month } = this.props.match.params;
    this.props.getAllTransactionRedux(id, this.getMonthName());
    let product = await getSingleProduct(id);
    this.setState({
      selectedMonth: this.getMonthName(),
      product: product,
      variationId:
        product.displayedVariations && product.displayedVariations.length > 0
          ? product.displayedVariations[0].id
          : "",
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  getMonthsBetween = (startMonth, endMonth) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let result = [];
    // Parse the start and end months
    const startDate = new Date(startMonth);
    const endDate = new Date(endMonth);

    // Generate the array of months in descending order
    let currentDate = endDate;
    while (currentDate >= startDate) {
      const monthName = months[currentDate.getMonth()];
      const year = currentDate.getFullYear();
      result.push(`${monthName},${year}`);
      // Move to the previous month
      currentDate.setMonth(currentDate.getMonth() - 1);
    }

    return result;
  };

  handleSubmit = async () => {
    let date = new Date();
    if (this.state.quantity > 0) {
      if (
        this.state.product.displayedVariations &&
        this.state.product.displayedVariations.length > 0
      ) {
        if (
          this.state.product.displayedVariations.find(
            (variation) => variation.id == this.state.variationId
          ).inventory &&
          this.state.product.displayedVariations.find(
            (variation) => variation.id == this.state.variationId
          ).inventory > 0
        ) {
          await this.props.updateSingleProductRedux({
            ...this.state.product,
            displayedVariations: this.state.product.displayedVariations.map(
              (variation) => {
                if (this.state.variationId == variation.id) {
                  return {
                    ...variation,
                    totalSold: variation.totalSold
                      ? variation.totalSold + parseInt(this.state.quantity)
                      : parseInt(this.state.quantity),
                    inventory:
                      parseInt(variation.inventory) -
                      parseInt(this.state.quantity),
                  };
                } else {
                  return variation;
                }
              }
            ),
          });
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + "1",
            fundType: "Selling",
            subCategory: this.state.subCategory,
            orderStatus: "Reduced",
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            totalBill: this.state.totalBill,
            perUnitPrice: this.state.perUnitPrice,
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            note: this.state.note,
            unEditable: true,
            productId: this.state.product.id,
            sellStock: this.state.quantity,
            remainingStock:
              parseInt(
                this.state.product.displayedVariations.find(
                  (variation) => variation.id == this.state.variationId
                ).inventory
              ) - parseInt(this.state.quantity),
            productName: this.state.product.name,
            productImage: this.state.product.pictures[0],
            variationId: this.state.variationId,
          });

          toast.success("Item quantity reduced");
          let product = await getSingleProduct(this.state.product.id);
          this.setState({
            subCategory: "",
            note: "",
            totalBill: 0,
            perUnitPrice: 0,
            quantity: 0,
            product: product,
          });
        } else {
          toast.error("Item quantity is already 0.");
        }
      } else {
        if (this.state.product.inventory > 0) {
          await this.props.updateSingleProductRedux({
            ...this.state.product,
            totalSold: this.state.product.totalSold
              ? this.state.product.totalSold + parseInt(this.state.quantity)
              : parseInt(this.state.quantity),
            inventory:
              parseInt(this.state.product.inventory) -
              parseInt(this.state.quantity),
          });
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + "1",
            fundType: "Selling",
            subCategory: this.state.subCategory,
            orderStatus: "Reduced",
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            totalBill: this.state.totalBill,
            perUnitPrice: this.state.perUnitPrice,
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: this.state.product.id,
            sellStock: this.state.quantity,
            remainingStock:
              parseInt(this.state.product.inventory) -
              parseInt(this.state.quantity),
            productName: this.state.product.name,
            productImage: this.state.product.pictures[0],
          });
          toast.success("Item quantity reduced");
          let product = await getSingleProduct(this.state.product.id);
          this.setState({
            subCategory: "",
            note: "",
            totalBill: 0,
            perUnitPrice: 0,
            quantity: 0,
            product: product,
          });
        } else {
          toast.error("Item quantity is already 0.");
        }
      }
    } else {
      alert("sold or reduced quantity must be greater than 0.");
    }
  };

  render() {
    const { sourcingObj } = this.state;
    const { sourcings, currentAdmin, transactions } = this.props;
    let productName = "";
    if (transactions && transactions.length > 0) {
      productName = transactions[0].productName;
    }
    let productImage = "";
    if (transactions && transactions.length > 0) {
      productImage = transactions[0].productImage;
    }
    let date = new Date();
    const startMonth = "February,2025";
    const endMonth = this.getMonthName();
    const monthsArray = this.getMonthsBetween(startMonth, endMonth);

    let sortedTransfers = transactions.sort((a, b) => b.id - a.id);
    if (
      this.state.product &&
      this.state.product.displayedVariations &&
      this.state.product.displayedVariations.length > 0
    ) {
      sortedTransfers = sortedTransfers.filter(
        (transfer) => transfer.variationId == this.state.variationId
      );
    }
    let stock = 0;
    let stockQuantity = 0;
    let sell = 0;
    let sellQuantity = 0;
    if (sortedTransfers && sortedTransfers.length > 0) {
      let notCancelled = sortedTransfers.filter(
        (transfer) => transfer.orderStatus !== "Cancelled"
      );
      notCancelled.map((transfer) => {
        if (transfer.fundType == "Selling") {
          sell += parseInt(transfer.totalBill);
          sellQuantity += parseInt(transfer.sellStock);
        } else {
          stock += parseInt(transfer.totalCost);
          stockQuantity += parseInt(transfer.productStock);
        }
      });
    }
    return (
      <Fragment>
        <Breadcrumb title={productName} parent="All Products" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div
            data-toggle="modal"
            data-target="#personalInfoModal"
            style={{
              marginTop: 20,
              marginLeft: 10,
              color: "white",
              background: "darkorange",
              borderRadius: 5,
              padding: 10,
              display: "inline-block",
              cursor: "pointer",
            }}
          >
            Manage stock
          </div>
          <div className="row" style={{ justifyContent: "center" }}>
            <>
              <div
                className="card o-hidden widget-cards"
                style={{
                  marginLeft: 10,
                  border: "2px solid white",
                }}
              >
                <div
                  className="card-body"
                  style={{
                    backgroundColor: "rgb(251, 148, 4)",
                    cursor: "pointer",
                  }}
                >
                  <div className="media static-top-widget row">
                    <div className="icons-widgets col-4">
                      <div className="align-self-center text-center">
                        <DollarSign className="font-warning" />
                      </div>
                    </div>
                    <div className="media-body col-8">
                      <span
                        className="m-0"
                        style={{
                          fontWeight: "bold",
                          fontSize: "100%",
                          color: "white",
                        }}
                      >
                        {this.state.selectedMonth} Stock
                        <br />
                        {stockQuantity}pc
                      </span>
                      <h3 className="mb-0" style={{ color: "darkorange" }}>
                        <CountUp className="counter" end={stock} />
                        Tk
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card o-hidden widget-cards"
                style={{
                  marginLeft: 10,
                  border: "2px solid white",
                }}
              >
                <div
                  className="card-body"
                  style={{
                    backgroundColor: "rgb(46 146 137)",
                    cursor: "pointer",
                  }}
                >
                  <div className="media static-top-widget row">
                    <div className="icons-widgets col-4">
                      <div className="align-self-center text-center">
                        <DollarSign className="font-warning" />
                      </div>
                    </div>
                    <div className="media-body col-8">
                      <span
                        className="m-0"
                        style={{
                          fontWeight: "bold",
                          fontSize: "100%",
                          color: "white",
                        }}
                      >
                        {this.state.selectedMonth} Sell <br />
                        {sellQuantity}pc
                      </span>
                      <h3 className="mb-0" style={{ color: "darkorange" }}>
                        <CountUp className="counter" end={sell} />
                        Tk
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="card o-hidden widget-cards"
                style={{
                  marginLeft: 10,
                  border: "2px solid white",
                }}
              >
                <div
                  className="card-body"
                  style={{
                    backgroundColor: "rgb(79 136 195)",
                    cursor: "pointer",
                  }}
                >
                  <div className="media static-top-widget row">
                    <div className="icons-widgets col-4">
                      <div className="align-self-center text-center">
                        <DollarSign className="font-warning" />
                      </div>
                    </div>
                    <div className="media-body col-8">
                      <span
                        className="m-0"
                        style={{
                          fontWeight: "bold",
                          fontSize: "100%",
                          color: "white",
                        }}
                      >
                        Available Stock
                      </span>
                      <h3 className="mb-0" style={{ color: "darkorange" }}>
                        <CountUp
                          className="counter"
                          end={
                            sortedTransfers && sortedTransfers.length > 0
                              ? sortedTransfers[0].remainingStock
                              : 0
                          }
                        />
                        pc
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </>

            <AllTransactions
              props={this.props}
              productId={this.props.match.params.id}
              month={this.state.selectedMonth}
              productImage={
                this.state.product && this.state.product.pictures[0]
              }
              productName={this.state.product && this.state.product.name}
              monthsArray={monthsArray}
              setSelectedMonth={(month) => {
                this.setState({
                  selectedMonth: month,
                });
                this.props.getAllTransactionRedux(
                  this.props.match.params.id,
                  month
                );
              }}
              setVariationId={(id) => {
                this.setState({
                  variationId: id,
                });
              }}
              variationId={this.state.variationId}
              product={this.state.product}
              sortedTransfers={sortedTransfers}
            />
          </div>
        </div>
        <ToastContainer />
        <div
          className="modal fade"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "95%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Reduce stock quantity
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Choose variation
                    </label>
                    <select
                      title="Please choose a package"
                      required
                      name="variationId"
                      className="custom-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={(e) => {
                        const { name, value } = e.target;
                        this.setState({
                          variationId: value,
                        });
                      }}
                      value={this.state.variationId}
                    >
                      <option value="">None</option>

                      {this.state.product &&
                        this.state.product.displayedVariations.map(
                          (variation) => (
                            <option value={variation.id}>
                              {variation.combination.map(
                                (comb) => `${comb.name},`
                              )}
                            </option>
                          )
                        )}
                    </select>
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Sub Category
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="subCategory"
                      value={this.state.subCategory}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="write short note"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Note
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="note"
                      value={this.state.note}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter description here"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Total Bill
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="totalBill"
                      value={this.state.totalBill}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="write total bill"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Per Unit Price
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="perUnitPrice"
                      value={this.state.perUnitPrice}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="per unit price"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Sold/Reduce Qunaity
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="quantity"
                      value={this.state.quantity}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter quantity"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkorange",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Reduce stock
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactions: state.products.transactions,
    currentAdmin: state.admins.currentAdmin,
  };
};

export default connect(mapStateToProps, {
  getAllTransactionRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
})(SellsReport);
